import React, { useState, useEffect } from 'react';
import ComejoinCard from '../about/comeJoin/ComejoinCard'
import './CareersLast.css'
import { images } from '../../assets';

function CareersLast() {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    let imgSrc;
  if (windowWidth <= 431) {
    imgSrc = images.comejoinBgMobile;
  } else if (windowWidth > 431 && windowWidth <= 821) {
    imgSrc = images.comejoinBgTablet; // Add the new image for tablet screens
  } else {
    imgSrc = images.comejoinBg;
  }

    const data = {
        id: 1,
        heading: "Did not find a role you are looking for?",
        desc: "Write to us anyway. We are always on the lookout for smart people passionate about solving for health and happiness for everyone else. ",
        img: imgSrc,
        button: "Send your Resume",
      };
    
      const customClass = {
        comejoin: "careersLast",
        comejoincomp: "careersLastcomp",
        comejoincard: "careersLastcard",
        comejoincontent: "careersLastcontent",
        comejoinheading: "careersLastheading",
        comejoindesc: "careersLastdesc",
        comejoinbutton: "careersLastbutton",
        seeoppurtunities: "sendResume",
      };
    
      return <ComejoinCard className={customClass} data={data} />;
}

export default CareersLast
